import { z } from "zod";

import { MetaDataSchema } from "@/types/meta-data";

export const SavedFilterSchema = z.object({
	id: z.number(),
	name: z.string(),
	filterConfig: z.record(z.string(), z.unknown()),
	companyId: z.number(),
	createdAt: z.string(),
	updatedAt: z.string(),
});

export const SavedFilterResponseSchema = z.object({
	data: z.array(SavedFilterSchema),
	meta: MetaDataSchema,
});

export const SavedFilterDeleteResponseSchema = z.object({
	success: z.boolean(),
});

export type SavedFilter = z.infer<typeof SavedFilterSchema>;
export type SavedFilterResponse = z.infer<typeof SavedFilterResponseSchema>;
export type SavedFilterDeleteResponse = z.infer<typeof SavedFilterDeleteResponseSchema>;
